const initialState = {
  replaceAccessUsers: [],
};

export default initialState;
